import React from "react";
import { motion } from "framer-motion";
import { Cpu, BarChart3, Bot, Layers3, Activity, Calendar } from "lucide-react";
import SectionHeading from "../SectionHeading";
import { staggerVariants, VIEWPORT_ONCE_TIGHT } from "../../lib/motion";

const features = [
    {
        icon: BarChart3,
        title: "Advanced Charting",
        copy: "21 timeframes, 38 indicators, 24 graphical objects, multi-chart layouts.",
    },
    {
        icon: Bot,
        title: "Algorithmic Trading",
        copy: "Build, backtest and deploy Expert Advisors written in MQL5 directly inside MT5.",
    },
    {
        icon: Layers3,
        title: "Depth of Market",
        copy: "Real-time order book on supported instruments for precise execution decisions.",
    },
    {
        icon: Activity,
        title: "One-Click Trading",
        copy: "Buy and sell straight from the chart with pre-set risk parameters.",
    },
    {
        icon: Calendar,
        title: "Economic Calendar",
        copy: "Native event feed with consensus, prior, and impact ratings.",
    },
    {
        icon: Cpu,
        title: "Multi-Asset Engine",
        copy: "Trade forex and crypto CFDs from one account, one platform.",
    },
];

const cardVariants = staggerVariants({ y: 20, duration: 0.5, step: 0.05 });

export default function PlatformFeatures() {
    return (
        <section className="py-24 lg:py-28">
            <div className="xpo-container">
                <SectionHeading
                    overline="Features"
                    title="Everything you need. Nothing in your way."
                    description="MT5 was built for professional traders — and stripped of bloat by XPO. The result: a platform that gets out of your way."
                    align="center"
                />
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
                    {features.map((f, i) => (
                        <motion.div
                            key={f.title}
                            variants={cardVariants}
                            initial="hidden"
                            whileInView="visible"
                            custom={i}
                            viewport={VIEWPORT_ONCE_TIGHT}
                            className="xpo-glass p-7"
                        >
                            <div className="w-11 h-11 rounded-xl bg-[#A6E3DC]/10 border border-[#A6E3DC]/20 grid place-items-center mb-5">
                                <f.icon size={20} className="text-[#A6E3DC]" />
                            </div>
                            <h3 className="text-lg font-bold text-white">
                                {f.title}
                            </h3>
                            <p className="text-slate-400 text-sm mt-2 leading-relaxed">
                                {f.copy}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
